import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { addToHistory } from "store/slice/url-history-slice";
const UrlHistoryList = (props) => {
  const baseEndPointArray = useRef(props?.baseUrls?.map(({ value }) => value));
  const location = useLocation();
  useEffect(() => {
    props.addToHistory({
      pathname: location.pathname,
      baseEndPointArray: baseEndPointArray.current,
    });
  }, [location]);
  return <></>;
};

const mapStateToProps = (state) => ({
  history: state.urlHistoryReducer.history,
});

const mapDispatchToProps = {
  addToHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(UrlHistoryList);
